import React, { useState } from 'react';

import { fabric } from 'fabric';

import __ from './../utils/translation';

import InputAmount from './InputAmount';
import { InputSelect, Option } from './InputSelect';
import { ChromePicker } from 'react-color';



const DrawSettings = ({ canvas }) => {

  const [drawSettings, setDrawSettings] = useState({
    width: 1,
    style: 'pencil',
    color: 'rgba(0,0,0,1)'
  })


  const handleBrushWidthChange = (action, amount) => {
    let width = 1

    if (action === 'decrease') {
      width = drawSettings.width
      width = width === 1 ? 1 : width - 1
    }

    if (action === 'increase') {
      width = drawSettings.width + 1
    }

    if (action === 'change') {
      width = parseInt(amount)
      if (!Number.isInteger(width)) return
    }

    setDrawSettings({
      ...drawSettings,
      width: width
    })

    canvas.freeDrawingBrush.width = width
  }


  const handleBrushStyleChange = (style) => {

    switch (style) {
      case 'circle':
        canvas.freeDrawingBrush = new fabric.CircleBrush(canvas)
        break

      case 'spray':
        canvas.freeDrawingBrush = new fabric.SprayBrush(canvas)
        break

      default:
        canvas.freeDrawingBrush = new fabric.PencilBrush(canvas)
        break
    }

    canvas.freeDrawingBrush.width = drawSettings.width
    canvas.freeDrawingBrush.color = drawSettings.color


    setDrawSettings({
      ...drawSettings,
      style: style
    })
  }


  const handleBrushColorChange = (color) => {
    setDrawSettings({
      ...drawSettings,
      color: `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`
    })

    canvas.freeDrawingBrush.color = `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`
  }


  return (
    <>
      {/**<p className="title lang" data-en="FREE DRAWING" data-pt="DESENHO LIVRE" data-es="DIBUJO GRATIS">{__('FREE DRAWING')}</p> */}
      <p className="mt-2 mb-5 text-justify">
        Para desenhar, clique no canvas, segure o mouse e arraste na direção desejada.
      </p>
      <div className="setting">
        <div className="label lang" data-en="Brush width" data-pt="Largura do pincel" data-es="Ancho del pincel">{__('Brush width')}</div><div className="function">
          <InputAmount unit="" value={drawSettings.width}
            handleDecrease={() => handleBrushWidthChange('decrease')}
            handleChange={(e) => handleBrushWidthChange('change', e.target.value)}
            handleIncrease={() => handleBrushWidthChange('increase')}
          />
        </div>
      </div>
      <div className="setting">
        <div className="label lang" data-en="Brush style" data-pt="Estilo do pincel" data-es="Estilo de pincel">{__('Brush style')}</div><div className="function">
          <InputSelect activeOption={drawSettings.style} handleChange={(style) => handleBrushStyleChange(style)}>
            <Option value="pencil">{__('Pencil')}</Option>
            <Option value="circle">{__('Circle')}</Option>
            <Option value="spray">{__('Spray')}</Option>
          </InputSelect>
        </div>
      </div>
      <div className="setting">
        <div className="label lang" data-en="Brush color" data-pt="Cor do pincel" data-es="Color del pincel">{__('Brush color')}</div><div className="function"></div>
      </div>
      <ChromePicker width="100%" color={drawSettings.color} onChange={handleBrushColorChange} />
      <p></p>
      <p><i className='lang' data-en="Dica: You can select and style each line you drew. Use Shift + Click to select multiple lines and
      group them into an object." data-pt="Dica: Você pode selecionar e estilizar cada linha que desenhou. Use Shift + Clique para selecionar várias linhas e
      agrupá-los em um objeto." data-es="Dica: Puedes seleccionar y diseñar cada línea que dibujaste. Utilice Mayús + clic para seleccionar varias líneas y
      agruparlos en un objeto.">{__(`Dica: You can select and style each line you drew. Use Shift + Click to select multiple lines and
      group them into an object.`)}</i></p>
    </>
  )
}


export default DrawSettings
